import templateUrl from "emun.invoice/inv/inv-details-lines.htm";

export default () => ({ templateUrl });
